import { render } from "./UploadTab.vue?vue&type=template&id=fc6fd5bc&scoped=true"
import script from "./UploadTab.vue?vue&type=script&lang=js"
export * from "./UploadTab.vue?vue&type=script&lang=js"

import "./UploadTab.vue?vue&type=style&index=0&id=fc6fd5bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6fd5bc"]])

export default __exports__